import React, { useEffect } from 'react'
import TextLabel from './TextLabel'
import MDBDropdown from './Dropdown'
import { FormRow } from '../../../styles/styled-component'
import Form from 'react-bootstrap/Form';
import { t } from 'i18next'
function DropdownInputWithLabel({ label, onDropdownChangeHandler, dropdownItems, disabled = false, rstSwitch, toggleRstSwitch, isMandatory }) {
  const [value, setValue] = React.useState(0);
  useEffect(() => {
    if (dropdownItems.length === 1) {
      onDropdownChangeHandler({id:dropdownItems[0].id, desc:dropdownItems[0].desc},0);
    }
  },[]);
  useEffect(() => {
    if(dropdownItems!==null || dropdownItems!==undefined){
      console.log("Dropdown changed == ", dropdownItems,value);
      setValue(0);
    }
  
    return () => {
      
    }
  }, [dropdownItems]);
  
  const onChange = (event) => {
    debugger;
    setValue(event.target.value);
  }
  useEffect(() => {
    if (rstSwitch) {
      setValue(-1);
      toggleRstSwitch();
    }
  },[rstSwitch]);
  return (
    <FormRow>
      <TextLabel isMandatory={isMandatory} title={label} />
      {/* <MDBDropdown rstSwitch={rstSwitch} toggleRstSwitch={toggleRstSwitch} disabled={disabled} onChange={onDropdownChangeHandler} items={dropdownItems} ></MDBDropdown> */}
      <>
        <Form.Select
          value={value}
          onChange={(event) => {
            onChange(event);
            onDropdownChangeHandler(event, 1);
          }}
          aria-label="Default select example"
          disabled={disabled}
        >
          {dropdownItems.length > 1 && <option value={-1}></option>}
          {dropdownItems.map((item, index) => {
            return (
              <option key={index} value={item.id}>
                {" "}
                {item.desc
                  ? item.desc
                  : item.name
                  ? item.name
                  : item.descr
                  ? item.descr
                  : item.description
                  ? item.description
                  : item.satisfactionLevel
                  ? item.satisfactionLevel
                  : item.deSatisfactionReason}
              </option>
            );
          })}
        </Form.Select>
      </>
    </FormRow>
  );
}

export default DropdownInputWithLabel